










import { Component, Mixins } from 'vue-property-decorator';
import HeaderComponent from '../ui-components/header/HeaderComponent.vue';
import FooterComponent from '../ui-components/footer/FooterComponent.vue';
import commonEntry from '@/store/modules/commonEntry';
import AccountSettings from '@/mixins/accountSettings.mixin';
import APP_UTILITIES from '@/utilities/commonFunctions';
import { getInstance } from '@/auth';

@Component({
  components: {
    'HeaderComponent': HeaderComponent,
    'FooterComponent': FooterComponent
  },
})
export default class Home extends Mixins(AccountSettings) {
  public apiResponse: boolean = false;
  handleRedirectFromOkta(slug: string): void {
    const authService = getInstance();
    if (!slug) {
      return;
    }
    if (
      window.location.search.includes('code=') &&
      window.location.search.includes('state=')
    ) {
      const searchParams = new URLSearchParams(window.location.search);
      const code = searchParams.get('code');
      const state = searchParams.get('state');
      const redirectUrl = `${window.location.origin}/${slug}/#/login?code=${code}&state=${state}&redirect=${authService.redirectTo}`;
      window.location.href = slug
        ? redirectUrl
        : window.location.pathname;
    }
  }

  /* istanbul ignore next */
  beforeMount() {
    try {
      let slug = APP_UTILITIES.accountSlug;
      this.handleRedirectFromOkta(slug);
      if (location.href && location.pathname !== '/' && !window.location.search.includes('callback')) {
        slug = slug && slug.replace(/\//g, '');
        commonEntry.getAccountDetailsBySlug(slug).then((data) => {
          this.logo = data.accountDesign && data.accountDesign.logoUrl;
          this.updateAccountDesignData(data.accountDesign);
          this.apiResponse = true;
          localStorage.setItem('accountDesign', JSON.stringify(data));
        });
      }
      else {
        this.$router.push('/login');
      }
    }
    catch (error) {
      this.$router.push('/login');
    }
  }
}
